const translation = {
  custom: 'Anpassung',
  upgradeTip: {
    prefix: 'Erweitere deinen Plan auf',
    suffix: 'um deine Marke anzupassen.',
  },
  webapp: {
    title: 'WebApp Marke anpassen',
    removeBrand: 'Entferne Powered by Dify',
    changeLogo: 'Ändere Powered by Markenbild',
    changeLogoTip: 'SVG oder PNG Format mit einer Mindestgröße von 40x40px',
  },
  app: {
    title: 'App Kopfzeilen Marke anpassen',
    changeLogoTip: 'SVG oder PNG Format mit einer Mindestgröße von 80x80px',
  },
  upload: 'Hochladen',
  uploading: 'Lade hoch',
  uploadedFail: 'Bild-Upload fehlgeschlagen, bitte erneut hochladen.',
  change: 'Ändern',
  apply: 'Anwenden',
  restore: 'Standardeinstellungen wiederherstellen',
  customize: {
    contactUs: ' kontaktiere uns ',
    prefix: 'Um das Markenlogo innerhalb der App anzupassen, bitte',
    suffix: 'um auf die Enterprise-Edition zu upgraden.',
  },
}

export default translation
